import React from 'react';

/**
 * Transactions Module for the Right Panel
 */
const TransactionsModule: React.FC = () => {
  return <div>TRANSACTIONS MODULE</div>;
};

export default TransactionsModule;
